module.exports = __webpack_public_path__ + "img/2021_10_dande_kochijo_a4_fin_web.c52636b7.png";